// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Mohave);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";



html, body {
  font-family: 'Mohave';
}

a {
  color: #0b58db;
  text-decoration: none;
}


a.disabled-link {
  pointer-events: none;
  cursor: default; /* optionnel */
  opacity: 0.6;    /* optionnel */
}


/* Text Input */
.basic_ti{
	height:40px;
	padding:6px;
	background:#fff;width:358px;
	border:1px solid #111;
	border-radius:4px;
}
.basic_ti_top{
	height:40px;
	padding:6px;
	background:#fff;
  width:358px;
	border:1px solid #111;
	border-radius:4px;
	border-bottom:none;
	-moz-border-radius-bottomleft:0px;
		-webkit-border-bottom-left-radius:0px;
		border-bottom-left-radius:0px;
		-moz-border-radius-bottomright:0px;
		-webkit-border-bottom-right-radius:0px;
		border-bottom-right-radius:0px;
}
.basic_ti_middle{
	height:40px;
	padding:6px;
	background:#fff;
  width:358px;
	border:1px solid #111;border-top:1px solid #bbb;
	border-bottom:none;
	border-radius:none;
	-moz-border-radius-topleft:0px;
			-webkit-border-radius:0px;
			border-radius:0px;
			-moz-border-radius:0px;
			-webkit-border-radius:0px;
			border-radius:0px;
}
.basic_ti_bottom{
	height:40px;
	padding:6px;
	background:#fff;width:358px;
      border-radius:4px;
	border:1px solid #111;border-top:1px solid #bbb;
	-moz-border-radius-topleft:0px;
			-webkit-border-top-left-radius:0px;
			border-top-left-radius:0px;
			-moz-border-radius-topright:0px;
			-webkit-border-top-right-radius:0px;
			border-top-right-radius:0px;
}




.basic_ti3 {
  height: 50px;
  padding: 6px;
  background: #fff;
  width: 358px;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline-style: none;
  box-shadow: none;
}

.basic_ti_top3 {
  height: 50px;
  padding: 6px;
  background: #fff;
  width: 358px;
  border: 1px solid #ccc;
  border-radius: 4px;
  border-bottom: none;
  -moz-border-radius-bottomleft: 0px;
  -webkit-border-bottom-left-radius: 0px;
  border-bottom-left-radius: 0px;
  -moz-border-radius-bottomright: 0px;
  -webkit-border-bottom-right-radius: 0px;
  border-bottom-right-radius: 0px;
  outline-style: none;
  box-shadow: none;
}

.basic_ti_middle3 {
  height: 50px;
  padding: 6px;
  background: #fff;
  width: 358px;
  border: 1px solid #ccc;
  border-top: 1px solid #ccc;
  border-bottom: none;
  border-radius: none;
  -moz-border-radius-topleft: 0px;
  -webkit-border-radius: 0px;
  border-radius: 0px;
  -moz-border-radius: 0px;
  -webkit-border-radius: 0px;
  border-radius: 0px;
  outline-style: none;
  box-shadow: none;
 }

.basic_ti_bottom3 {
  height: 50px;
  padding: 6px;
  background: #fff;
  width: 358px;
  border-radius: 4px;
  border: 1px solid #ccc;
  border-top: 1px solid #ccc;
  -moz-border-radius-topleft: 0px;
  -webkit-border-top-left-radius: 0px;
  border-top-left-radius: 0px;
  -moz-border-radius-topright: 0px;
  -webkit-border-top-right-radius: 0px;
  border-top-right-radius: 0px;
  outline-style: none;
  box-shadow: none;
}


/* BUTTON */
.buttonBlackText2 {
	color: #000;
      font-size: 1.3rem;
     font-weight: 400;
     text-align: center;
     width: 200px ;
	 height: 50px;
     justify-content: center;
    line-height: 50px;
   border-radius: 6px;
   cursor:pointer;
}

.buttonWhiteText2 {
	color: #fff;
      font-size: 1.3rem;
     font-weight: 400;
     text-align: center;
     width: 200px ;
	 height: 50px;
     justify-content: center;
    line-height: 50px;
   border-radius: 6px;
   cursor:pointer;
}

.gradient-border {
  position: relative;
  background: white;
}

.gradient-border::before {
  content: "";
  position: absolute;
  inset: 0;
  padding: 2px; /* épaisseur */
  border-radius: inherit;
  background: linear-gradient(90deg, #00c6ff, #0072ff, #ff6a00, #ee0979);
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
          mask-composite: exclude;
}



.blue-button-pc {
  cursor: pointer;
  background: #0079ff;
  text-align: center;
  line-height: 60px;
  color: #fff;
  font-size: 1.5rem;
  border: 0.5px solid #0079ff;
  width: 230px;
  height: 60px;
  border-radius: 6px
}

.blue-button-disabled-pc {
  opacity: 0.3;
  cursor: default;
  background: #0079ff;
  text-align: center;
  line-height: 60px;
  color: #fff;
  font-size: 1.5rem;
  border: 0.5px solid #0079ff;
  width: 230px;
  height: 60px;
  border-radius: 6px
}

.cancel-button-pc {
  cursor: pointer;
  background: #fff;
  text-align: center;
  line-height: 60px;
  color: #0079ff;
  font-size: 1.5rem;
  border: 0.5px solid #0079ff;
  width: 230px;
  height: 60px;
  border-radius: 6px
}



.blue-button-phone {
  cursor: pointer;
  background: #0079ff;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 1rem;
  border: 0.5px solid #0079ff;
  width: 160px;
  height: 50px;
  border-radius: 6px
}

.blue-button-disabled-phone {
  opacity: 0.3;
  cursor: default;
  background: #0079ff;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 1rem;
  border: 0.5px solid #0079ff;
  width: 160px;
  height: 50px;
  border-radius: 6px
}

.cancel-button-phone {
  cursor: pointer;
  background: #fff;
  text-align: center;
  line-height: 50px;
  color: #0079ff;
  font-size: 1rem;
  border: 0.5px solid #0079ff;
  width: 160px;
  height: 50px;
  border-radius: 6px
}


.gradient-text {
  background: linear-gradient(to right, #00c6ff, #0072ff, #ff6a00, #ee0979);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text; /* pour compatibilité étendue */
  color: transparent;
}


.video-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.video-bg {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
  transform: translate(-50%, -50%);
  object-fit: cover;
}

.video-bg-mobile {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
  transform: translate(-42%, -50%);
  object-fit: cover;
}

.video-bg-mobile-bottom {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
  transform: translate(-42%, -90%);
  object-fit: cover;
}


.video-bg-tablet {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
  transform: translate(-42%, -50%);
  object-fit: cover;
}


.video-bg-tablet-bottom {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
  transform: translate(-42%, -80%);
  object-fit: cover;
}






.content-overlay {
  position: relative;
  z-index: 1;
  color: white;
  text-align: center;
  padding-top: 20vh;
}


.gradient-background {
  background-color: #dcddf7;
  position: relative;
  overflow: hidden;
}

.gradient-background::after {
  content: "";
  position: absolute;
  top: 80%;
  left: 0;
  width: 100%;
  height: 20%;
  background: linear-gradient(to bottom, rgba(220, 221, 247, 1), rgba(220, 221, 247, 0));
  pointer-events: none; /* Ensures it doesn't block clicks */
}

/* BUTTON */
.buttonBlackText {
	color: #000;
      font-size: 1.3rem;
     font-weight: 400;
     text-align: center;
     width: 200px ;
	 height: 50px;
     justify-content: center;
    line-height: 50px;
   border-radius: 6px;
   cursor:pointer;
}

.buttonWhiteText {
	color: #fff;
      font-size: 1.3rem;
     font-weight: 400;
     text-align: center;
     width: 200px ;
	 height: 50px;
     justify-content: center;
   border-radius: 6px;
   cursor:pointer;
}



.buttonBlackText3 {
  color: #000;
  font-size: 17px;
  font-weight: 400;
  text-align: center;
  width: 200px;
  height: 50px;
  justify-content: center;
  line-height: 50px;
  border-radius: 4px;
  cursor: pointer;
}

.buttonWhiteText3 {
  color: #fff;
  font-size: 17px;
  font-weight: 400;
  text-align: center;
  width: 200px;
  height: 50px;
  justify-content: center;
  line-height: 50px;
  border-radius: 4px;
  cursor: pointer;
}


.hero-section {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.parallax-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.hero-content {
  position: relative;
  z-index: 10;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 1rem;
}

.hero-title {
  color: #fff;
  font-size: 3rem;
  line-height: 3.1rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
}


.hero-title-pc {
  color: #fff;
  font-size: 2.4rem;
  line-height: 2.6rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
}

/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .hero-title-pc {
    font-size: 2.6rem;
    line-height: 2.7rem;
  }
}

/* Above 1400px */
@media (min-width: 1401px) {
  .hero-title-pc {
    font-size: 3rem;
    line-height: 3.1rem;
  }
}

.hero-title-mobile {
  color: #fff;
  font-size: 2.5rem;
  line-height: 2.6rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
}



.highlight {
  color: #facc15; /* jaune doré */
}

.hero-subtitle {
  margin-top: 1rem;
  font-size: 2.3rem;
  line-height: 2rem;
  color: white;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
}

.big-dec-txt-pc {
  font-size: 5rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .big-dec-txt-pc {
    font-size: 6.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .big-dec-txt-pc {
    font-size: 8rem;
  }
}


.mid-dec-txt-pc {
  font-size: 3rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .mid-dec-txt-pc {
    font-size: 4.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .mid-dec-txt-pc {
    font-size: 4rem;
  }
}


.mid-dec-txt-tablet {
  font-size: 3.3rem;
}

.mid-dec-txt-phone {
  font-size: 2rem;
}



.big-dec-txt-subtxt-pc {
  font-size: 1.6rem;
  line-height: 1.8rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .big-dec-txt-subtxt-pc {
    font-size: 1.8rem;
    line-height: 2rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .big-dec-txt-subtxt-pc {
    font-size: 2rem;
    line-height: 2.2rem;
  }
}






.small-box-txt-sz-pc {
  font-size: 21px;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .small-box-txt-sz-pc {
    font-size: 25px;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .small-box-txt-sz-pc {
    font-size: 5rem;
  }
}


.small-box-small-txt-sz-pc {
  font-size: 17px;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .small-box-small-txt-sz-pc {
    font-size: 18px;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .small-box-small-txt-sz-pc {
    font-size: 20px;
  }
}


.page-title-phone {
  font-size: 1.8rem;
}


.page-title-pc {
  font-size: 2.3rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .page-title-pc {
    font-size: 2.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .page-title-pc {
    font-size: 2.7rem;
  }
}

.page-subtitle-pc {
  font-size: 2rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .page-subtitle-pc {
    font-size: 2.3rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .page-subtitle-pc {
    font-size: 2.5rem;
  }
}


.page-subsubtitle-pc {
  font-size: 1.3rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .page-subsubtitle-pc {
    font-size: 1.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .page-subsubtitle-pc {
    font-size: 1.7rem;
  }
}


.page-subsubtitle-phone {
  font-size: 1rem;
  line-height: 1.2rem;
}


.menu-name-pc {
  font-size: 16px;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .menu-name-pc {
    font-size: 17px;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .menu-name-pc {
    font-size: 18px;
  }
}


.menu-name-tablet {
  font-size: 17px;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .menu-name-tablet {
    font-size: 18px;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .menu-name-tablet {
    font-size: 19px;
  }
}


.motion-h1-pc {
  font-size: 2rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-h1-pc {
    font-size: 2.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-h1-pc {
    font-size: 2.8rem;
  }
}

.motion-h1-sub-pc {
  font-size: 1.7rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-h1-sub-pc {
    font-size: 1.8rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-h1-sub-pc {
    font-size: 1.9rem;
  }
}


.motion-h1-sub-phone {
  font-size: 1.4rem;
}


.img-border-radius-pc {
  border-radius: 0.7rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .img-border-radius-pc {
    border-radius: 0.9rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .img-border-radius-pc {
    border-radius: 1rem;
  }
}



.motion-div-small-pc {
  font-size: 1rem;
  line-height: 1.3rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-div-small-pc {
    font-size: 1.2rem;
    line-height: 1.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-div-small-pc {
    font-size: 1.5rem;
    line-height: 1.8rem;
  }
}


.motion-div-small-tablet {
  font-size: 1.3rem;
  line-height: 1.6rem;
}

.motion-div-small-phone {
  font-size: 1rem;
  line-height: 1.2rem;
}



.motion-div-smallest-pc {
  font-size: 0.9rem;
  line-height: 1.1rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-div-smallest-pc {
    font-size: 1.1rem;
    line-height: 1.3rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-div-smallest-pc {
    font-size: 1.3rem;
    line-height: 1.5rem;
  }
}



.motion-div-default-pc {
  font-size: 1.1rem;
  line-height: 1.3rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-div-default-pc {
    font-size: 1.3rem;
    line-height: 1.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-div-default-pc {
    font-size: 1.6rem;
    line-height: 1.9rem;
  }
}



.motion-div-title-pc {
  font-size: 1.7rem;
  line-height: 1.9rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-div-title-pc {
    font-size: 2.3rem;
    line-height: 2.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-div-title-pc {
    font-size: 2.5rem;
    line-height: 2.7rem;
  }
}



.motion-div-subtitle-pc {
  font-size: 1.4rem;
  line-height: 1.6rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-div-subtitle-pc {
    font-size: 2rem;
    line-height: 2.2rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-div-subtitle-pc {
    font-size: 2.2rem;
    line-height: 2.4rem;
  }
}




/* HEADER */
.menu-modal-transl {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.main_header {
	position:fixed;
	z-index:99;
	top:10px;
	right: 25px;
   width: 100%;
   height: 70px;
  border-bottom: rgba(53,3,176,1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.main_header_okd {
	position:fixed;
	z-index:99;
	top:0;
	left: 0;
   width: 100%;
   height: 70px;
  border-bottom: rgba(53,3,176,1);
  background: rgb(53,3,176);
background: -moz-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);
background: -webkit-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);
background: linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);
filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#3503b0",endColorstr="#9e10bf",GradientType=1);
}

.main_header_connected{
	position:fixed;
	z-index:9;
	top:0;
	left: 0;
   width: 100%;
   height: 70px;
   background: rgb(53,3,176);
 background: -moz-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);
 background: -webkit-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);
 background: linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);
 filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#3503b0",endColorstr="#9e10bf",GradientType=1);
  overflow: hidden;
}


.main_header_inside {
	width: 98%;
       height: 60px;
	margin: auto;
	margin-top:5px;
      overflow: hidden;
}

.main_header_inside_mobile {
	width: 98%;
       height: 50px;
	margin: auto;
	margin-top:5px;
      overflow: hidden;
}




.main_header_inside_left {
       width: 170px;
       height: 50px;
	    justify-content: center;
	   line-height: 50px;
	   float: left;
}

.main_header_inside_left_2 {
       height: 50px;
	    justify-content: center;
	   line-height: 50px;
	   float: left;
	   margin-left: 30px;
}

.main_header_inside_left_2 a{
	display: inline-block;
	width: 100px;
	text-align: center;
	font-size: 16px;
}


.main_header_inside_left img{
	width: 170px;
	 vertical-align: middle;
}

.main_header_inside_left_mobile {
	width: 30%;
       height: 50px;
	    justify-content: center;
	   line-height: 50px;
	   float: left;
}
.main_header_inside_left_mobile img{
	width: 100%;
	 vertical-align: middle;
}



.main_header_inside_center {
	margin-left: 20px;
	width: 480px;
       height: 44px;
	   margin-top:3px;
    justify-content: center;
	 float: left;
}




.main_header_inside_center_mobile {
	text-align:  center;
	width: 40%;
       height: 50px;
	   line-height: 50px;
	   float: left;
}
.main_header_inside_center_mobile img{
	width: 100%;
	 vertical-align: middle;
}


.main_header_inside_right {
	position: relative;
	text-align:  right;
	width: 350px;
       height: 50px;
	   float: right;
}
.main_header_inside_right img{
	height: 50px;
	 vertical-align: middle;
}


.main_header_inside_right_1 {
	position: relative;
	   float: right;
	   margin-left:20px;
	     margin-top:5px;
}

.main_header_inside_right_2 {
	position: relative;
	   float: right;
	   margin-top:5px;
}


.main_header_inside_right_mobile {
	position: relative;
	text-align:  right;
	width: 30%;
       height: 50px;
	     line-height: 50px;
	   float: right;
}
.main_header_inside_right_mobile img{
	width: 100%;
	 vertical-align: middle;
}



.menu_container {
  position: fixed;
  top: 19px;
  right: 7px;
  height: 27px;
  width: 35px;
  cursor: pointer;
  z-index: 9999;
  transition: opacity .25s ease;

  &:hover {
    opacity: 1;
  }

  &.active {
    .top {
      transform: translateY(11px) translateX(0) rotate(45deg);
      background: #777;
    }
    .middle {
      opacity: 0;
      background: #777;
    }

    .bottom {
      transform: translateY(-11px) translateX(0) rotate(-45deg);
      background: #777;
    }
  }

  span {
  background: #fff;
  border: none;
  height: 3px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transition:  all .35s ease;
  cursor: pointer;

    &:nth-of-type(2) {
      top: 11px;
    }

    &:nth-of-type(3) {
      top: 22px;
    }
  }
}



.overlay {
  position: fixed;
   z-index: 10;
  background: #fff;
  top: 0;
  left: 0;
  width: 100%;
  height: 0%;
  opacity: 0;
  visibility: hidden;
  transition: opacity .35s, visibility .35s, height .35s;
  overflow: hidden;

  &.open {
    opacity: 1;
    visibility: visible;
    height: 100%;

    li {
      animation: fadeInRight .5s ease forwards;
      animation-delay: .35s;

      &:nth-of-type(2) {
        animation-delay: .4s;
      }
      &:nth-of-type(3) {
        animation-delay: .45s;
      }
      &:nth-of-type(4) {
        animation-delay: .50s;
      }
    }
  }
  nav {
    position: relative;
    height: 70%;
    top: 35%;
    transform: translateY(-50%);
    font-size: 20px;
    font-family: 'Lato', sans-serif;
    font-weight: 400;
    text-align: center;
    width: 98% ;
	margin: auto;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    display: inline-block;
    position: relative;
    height: 100%;
     width: 100% ;

    li {
      display: block;
      height: 50px;
      min-height: 50px;
	  line-height: 50px;
	  width: 100% ;
      position: relative;
      opacity: 0;

      a {
        display: block;
        position: relative;
        color: #333;
        text-decoration: none;
        overflow: hidden;
        vertical-align: middle;

        &:hover:after,
         &:focus:after,
         &:active:after {
           width: 100%;
         }

        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 0%;
          transform: translateX(-50%);
          height: 3px;
          background: #FFF;
          transition: .35s;
        }
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gBAAgB;;;;AAKhB;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;;AAGA;EACE,oBAAoB;EACpB,eAAe,EAAE,cAAc;EAC/B,YAAY,KAAK,cAAc;AACjC;;;AAGA,eAAe;AACf;CACC,WAAW;CACX,WAAW;CACX,eAAe,CAAC,WAAW;CAC3B,qBAAqB;CACrB,iBAAiB;AAClB;AACA;CACC,WAAW;CACX,WAAW;CACX,eAAe;EACd,WAAW;CACZ,qBAAqB;CACrB,iBAAiB;CACjB,kBAAkB;CAClB,iCAAiC;EAChC,qCAAqC;EACrC,6BAA6B;EAC7B,kCAAkC;EAClC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;CACC,WAAW;CACX,WAAW;CACX,eAAe;EACd,WAAW;CACZ,qBAAqB,CAAC,yBAAyB;CAC/C,kBAAkB;CAClB,kBAAkB;CAClB,8BAA8B;GAC5B,yBAAyB;GACzB,iBAAiB;GACjB,sBAAsB;GACtB,yBAAyB;GACzB,iBAAiB;AACpB;AACA;CACC,WAAW;CACX,WAAW;CACX,eAAe,CAAC,WAAW;MACtB,iBAAiB;CACtB,qBAAqB,CAAC,yBAAyB;CAC/C,8BAA8B;GAC5B,kCAAkC;GAClC,0BAA0B;GAC1B,+BAA+B;GAC/B,mCAAmC;GACnC,2BAA2B;AAC9B;;;;;AAKA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,sCAAsC;EACtC,8BAA8B;EAC9B,mCAAmC;EACnC,uCAAuC;EACvC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;CACjB;;AAED;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,mCAAmC;EACnC,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;EACpC,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA,WAAW;AACX;CACC,WAAW;MACN,iBAAiB;KAClB,gBAAgB;KAChB,kBAAkB;KAClB,aAAa;EAChB,YAAY;KACT,uBAAuB;IACxB,iBAAiB;GAClB,kBAAkB;GAClB,cAAc;AACjB;;AAEA;CACC,WAAW;MACN,iBAAiB;KAClB,gBAAgB;KAChB,kBAAkB;KAClB,aAAa;EAChB,YAAY;KACT,uBAAuB;IACxB,iBAAiB;GAClB,kBAAkB;GAClB,cAAc;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY,EAAE,cAAc;EAC5B,sBAAsB;EACtB,sEAAsE;EACtE;;6BAE2B;EAC3B,2BAA2B;UACnB,uBAAuB;AACjC;;;;AAIA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ;AACF;;;;AAIA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ;AACF;;;AAGA;EACE,yEAAyE;EACzE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB,EAAE,+BAA+B;EACtD,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,iBAAiB;AACnB;;;;;;;AAOA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;EACX,sFAAsF;EACtF,oBAAoB,EAAE,oCAAoC;AAC5D;;AAEA,WAAW;AACX;CACC,WAAW;MACN,iBAAiB;KAClB,gBAAgB;KAChB,kBAAkB;KAClB,aAAa;EAChB,YAAY;KACT,uBAAuB;IACxB,iBAAiB;GAClB,kBAAkB;GAClB,cAAc;AACjB;;AAEA;CACC,WAAW;MACN,iBAAiB;KAClB,gBAAgB;KAChB,kBAAkB;KAClB,aAAa;EAChB,YAAY;KACT,uBAAuB;GACzB,kBAAkB;GAClB,cAAc;AACjB;;;;AAIA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;AAC3C;;;AAGA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;AAC3C;;;;AAIA;EACE,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;;;AAIA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;;;;;;AAOA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,eAAe;EACjB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,eAAe;EACjB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;AACnB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE,iBAAiB;AACnB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,eAAe;EACjB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,eAAe;EACjB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;AACnB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE,iBAAiB;AACnB;;;AAGA;EACE,qBAAqB;AACvB;AACA,8BAA8B;AAC9B;EACE;IACE,qBAAqB;EACvB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,mBAAmB;EACrB;AACF;;;;AAIA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;;;AAIA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;;;AAIA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;;;AAIA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;;;AAIA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;;;;AAKA,WAAW;AACX;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;CACC,cAAc;CACd,UAAU;CACV,QAAQ;CACR,WAAW;GACT,WAAW;GACX,YAAY;EACb,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;CACC,cAAc;CACd,UAAU;CACV,KAAK;CACL,OAAO;GACL,WAAW;GACX,YAAY;EACb,+BAA+B;EAC/B,yBAAyB;AAC3B,qFAAqF;AACrF,wFAAwF;AACxF,gFAAgF;AAChF,gHAAgH;AAChH;;AAEA;CACC,cAAc;CACd,SAAS;CACT,KAAK;CACL,OAAO;GACL,WAAW;GACX,YAAY;GACZ,yBAAyB;CAC3B,qFAAqF;CACrF,wFAAwF;CACxF,gFAAgF;CAChF,gHAAgH;EAC/G,gBAAgB;AAClB;;;AAGA;CACC,UAAU;OACJ,YAAY;CAClB,YAAY;CACZ,cAAc;MACT,gBAAgB;AACtB;;AAEA;CACC,UAAU;OACJ,YAAY;CAClB,YAAY;CACZ,cAAc;MACT,gBAAgB;AACtB;;;;;AAKA;OACO,YAAY;OACZ,YAAY;KACd,uBAAuB;IACxB,iBAAiB;IACjB,WAAW;AACf;;AAEA;OACO,YAAY;KACd,uBAAuB;IACxB,iBAAiB;IACjB,WAAW;IACX,iBAAiB;AACrB;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,kBAAkB;CAClB,eAAe;AAChB;;;AAGA;CACC,YAAY;EACX,sBAAsB;AACxB;;AAEA;CACC,UAAU;OACJ,YAAY;KACd,uBAAuB;IACxB,iBAAiB;IACjB,WAAW;AACf;AACA;CACC,WAAW;EACV,sBAAsB;AACxB;;;;AAIA;CACC,iBAAiB;CACjB,YAAY;OACN,YAAY;IACf,cAAc;IACd,uBAAuB;EACzB,WAAW;AACb;;;;;AAKA;CACC,mBAAmB;CACnB,UAAU;OACJ,YAAY;IACf,iBAAiB;IACjB,WAAW;AACf;AACA;CACC,WAAW;EACV,sBAAsB;AACxB;;;AAGA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;OACN,YAAY;IACf,YAAY;AAChB;AACA;CACC,YAAY;EACX,sBAAsB;AACxB;;;AAGA;CACC,kBAAkB;IACf,YAAY;IACZ,gBAAgB;MACd,cAAc;AACpB;;AAEA;CACC,kBAAkB;IACf,YAAY;IACZ,cAAc;AAClB;;;AAGA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;OACJ,YAAY;MACb,iBAAiB;IACnB,YAAY;AAChB;AACA;CACC,WAAW;EACV,sBAAsB;AACxB;;;;AAIA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,6BAA6B;;EAE7B;IACE,UAAU;EACZ;;EAEA;IACE;MACE,uDAAuD;MACvD,gBAAgB;IAClB;IACA;MACE,UAAU;MACV,gBAAgB;IAClB;;IAEA;MACE,yDAAyD;MACzD,gBAAgB;IAClB;EACF;;EAEA;EACA,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,0BAA0B;EAC1B,eAAe;;IAEb;MACE,SAAS;IACX;;IAEA;MACE,SAAS;IACX;EACF;AACF;;;;AAIA;EACE,eAAe;GACd,WAAW;EACZ,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,sDAAsD;EACtD,gBAAgB;;EAEhB;IACE,UAAU;IACV,mBAAmB;IACnB,YAAY;;IAEZ;MACE,wCAAwC;MACxC,qBAAqB;;MAErB;QACE,oBAAoB;MACtB;MACA;QACE,qBAAqB;MACvB;MACA;QACE,qBAAqB;MACvB;IACF;EACF;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;CACd,YAAY;EACX;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;KACX,YAAY;;IAEb;MACE,cAAc;MACd,YAAY;MACZ,gBAAgB;GACnB,iBAAiB;GACjB,YAAY;MACT,kBAAkB;MAClB,UAAU;;MAEV;QACE,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX,qBAAqB;QACrB,gBAAgB;QAChB,sBAAsB;;QAEtB;;;WAGG,WAAW;SACb;;QAED;UACE,WAAW;UACX,kBAAkB;UAClB,SAAS;UACT,SAAS;UACT,SAAS;UACT,2BAA2B;UAC3B,WAAW;UACX,gBAAgB;UAChB,gBAAgB;QAClB;MACF;IACF;EACF;AACF","sourcesContent":["@charset \"UTF-8\";\n@import url(https://fonts.googleapis.com/css?family=Mohave);\n\n\n\nhtml, body {\n  font-family: 'Mohave';\n}\n\na {\n  color: #0b58db;\n  text-decoration: none;\n}\n\n\na.disabled-link {\n  pointer-events: none;\n  cursor: default; /* optionnel */\n  opacity: 0.6;    /* optionnel */\n}\n\n\n/* Text Input */\n.basic_ti{\n\theight:40px;\n\tpadding:6px;\n\tbackground:#fff;width:358px;\n\tborder:1px solid #111;\n\tborder-radius:4px;\n}\n.basic_ti_top{\n\theight:40px;\n\tpadding:6px;\n\tbackground:#fff;\n  width:358px;\n\tborder:1px solid #111;\n\tborder-radius:4px;\n\tborder-bottom:none;\n\t-moz-border-radius-bottomleft:0px;\n\t\t-webkit-border-bottom-left-radius:0px;\n\t\tborder-bottom-left-radius:0px;\n\t\t-moz-border-radius-bottomright:0px;\n\t\t-webkit-border-bottom-right-radius:0px;\n\t\tborder-bottom-right-radius:0px;\n}\n.basic_ti_middle{\n\theight:40px;\n\tpadding:6px;\n\tbackground:#fff;\n  width:358px;\n\tborder:1px solid #111;border-top:1px solid #bbb;\n\tborder-bottom:none;\n\tborder-radius:none;\n\t-moz-border-radius-topleft:0px;\n\t\t\t-webkit-border-radius:0px;\n\t\t\tborder-radius:0px;\n\t\t\t-moz-border-radius:0px;\n\t\t\t-webkit-border-radius:0px;\n\t\t\tborder-radius:0px;\n}\n.basic_ti_bottom{\n\theight:40px;\n\tpadding:6px;\n\tbackground:#fff;width:358px;\n      border-radius:4px;\n\tborder:1px solid #111;border-top:1px solid #bbb;\n\t-moz-border-radius-topleft:0px;\n\t\t\t-webkit-border-top-left-radius:0px;\n\t\t\tborder-top-left-radius:0px;\n\t\t\t-moz-border-radius-topright:0px;\n\t\t\t-webkit-border-top-right-radius:0px;\n\t\t\tborder-top-right-radius:0px;\n}\n\n\n\n\n.basic_ti3 {\n  height: 50px;\n  padding: 6px;\n  background: #fff;\n  width: 358px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  outline-style: none;\n  box-shadow: none;\n}\n\n.basic_ti_top3 {\n  height: 50px;\n  padding: 6px;\n  background: #fff;\n  width: 358px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  border-bottom: none;\n  -moz-border-radius-bottomleft: 0px;\n  -webkit-border-bottom-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  -moz-border-radius-bottomright: 0px;\n  -webkit-border-bottom-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n  outline-style: none;\n  box-shadow: none;\n}\n\n.basic_ti_middle3 {\n  height: 50px;\n  padding: 6px;\n  background: #fff;\n  width: 358px;\n  border: 1px solid #ccc;\n  border-top: 1px solid #ccc;\n  border-bottom: none;\n  border-radius: none;\n  -moz-border-radius-topleft: 0px;\n  -webkit-border-radius: 0px;\n  border-radius: 0px;\n  -moz-border-radius: 0px;\n  -webkit-border-radius: 0px;\n  border-radius: 0px;\n  outline-style: none;\n  box-shadow: none;\n }\n\n.basic_ti_bottom3 {\n  height: 50px;\n  padding: 6px;\n  background: #fff;\n  width: 358px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  border-top: 1px solid #ccc;\n  -moz-border-radius-topleft: 0px;\n  -webkit-border-top-left-radius: 0px;\n  border-top-left-radius: 0px;\n  -moz-border-radius-topright: 0px;\n  -webkit-border-top-right-radius: 0px;\n  border-top-right-radius: 0px;\n  outline-style: none;\n  box-shadow: none;\n}\n\n\n/* BUTTON */\n.buttonBlackText2 {\n\tcolor: #000;\n      font-size: 1.3rem;\n     font-weight: 400;\n     text-align: center;\n     width: 200px ;\n\t height: 50px;\n     justify-content: center;\n    line-height: 50px;\n   border-radius: 6px;\n   cursor:pointer;\n}\n\n.buttonWhiteText2 {\n\tcolor: #fff;\n      font-size: 1.3rem;\n     font-weight: 400;\n     text-align: center;\n     width: 200px ;\n\t height: 50px;\n     justify-content: center;\n    line-height: 50px;\n   border-radius: 6px;\n   cursor:pointer;\n}\n\n.gradient-border {\n  position: relative;\n  background: white;\n}\n\n.gradient-border::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  padding: 2px; /* épaisseur */\n  border-radius: inherit;\n  background: linear-gradient(90deg, #00c6ff, #0072ff, #ff6a00, #ee0979);\n  -webkit-mask:\n    linear-gradient(#fff 0 0) content-box,\n    linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n          mask-composite: exclude;\n}\n\n\n\n.blue-button-pc {\n  cursor: pointer;\n  background: #0079ff;\n  text-align: center;\n  line-height: 60px;\n  color: #fff;\n  font-size: 1.5rem;\n  border: 0.5px solid #0079ff;\n  width: 230px;\n  height: 60px;\n  border-radius: 6px\n}\n\n.blue-button-disabled-pc {\n  opacity: 0.3;\n  cursor: default;\n  background: #0079ff;\n  text-align: center;\n  line-height: 60px;\n  color: #fff;\n  font-size: 1.5rem;\n  border: 0.5px solid #0079ff;\n  width: 230px;\n  height: 60px;\n  border-radius: 6px\n}\n\n.cancel-button-pc {\n  cursor: pointer;\n  background: #fff;\n  text-align: center;\n  line-height: 60px;\n  color: #0079ff;\n  font-size: 1.5rem;\n  border: 0.5px solid #0079ff;\n  width: 230px;\n  height: 60px;\n  border-radius: 6px\n}\n\n\n\n.blue-button-phone {\n  cursor: pointer;\n  background: #0079ff;\n  text-align: center;\n  line-height: 50px;\n  color: #fff;\n  font-size: 1rem;\n  border: 0.5px solid #0079ff;\n  width: 160px;\n  height: 50px;\n  border-radius: 6px\n}\n\n.blue-button-disabled-phone {\n  opacity: 0.3;\n  cursor: default;\n  background: #0079ff;\n  text-align: center;\n  line-height: 50px;\n  color: #fff;\n  font-size: 1rem;\n  border: 0.5px solid #0079ff;\n  width: 160px;\n  height: 50px;\n  border-radius: 6px\n}\n\n.cancel-button-phone {\n  cursor: pointer;\n  background: #fff;\n  text-align: center;\n  line-height: 50px;\n  color: #0079ff;\n  font-size: 1rem;\n  border: 0.5px solid #0079ff;\n  width: 160px;\n  height: 50px;\n  border-radius: 6px\n}\n\n\n.gradient-text {\n  background: linear-gradient(to right, #00c6ff, #0072ff, #ff6a00, #ee0979);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text; /* pour compatibilité étendue */\n  color: transparent;\n}\n\n\n.video-container {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.video-bg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  z-index: -1;\n  transform: translate(-50%, -50%);\n  object-fit: cover;\n}\n\n.video-bg-mobile {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  z-index: -1;\n  transform: translate(-42%, -50%);\n  object-fit: cover;\n}\n\n.video-bg-mobile-bottom {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  z-index: -1;\n  transform: translate(-42%, -90%);\n  object-fit: cover;\n}\n\n\n.video-bg-tablet {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  z-index: -1;\n  transform: translate(-42%, -50%);\n  object-fit: cover;\n}\n\n\n.video-bg-tablet-bottom {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  z-index: -1;\n  transform: translate(-42%, -80%);\n  object-fit: cover;\n}\n\n\n\n\n\n\n.content-overlay {\n  position: relative;\n  z-index: 1;\n  color: white;\n  text-align: center;\n  padding-top: 20vh;\n}\n\n\n.gradient-background {\n  background-color: #dcddf7;\n  position: relative;\n  overflow: hidden;\n}\n\n.gradient-background::after {\n  content: \"\";\n  position: absolute;\n  top: 80%;\n  left: 0;\n  width: 100%;\n  height: 20%;\n  background: linear-gradient(to bottom, rgba(220, 221, 247, 1), rgba(220, 221, 247, 0));\n  pointer-events: none; /* Ensures it doesn't block clicks */\n}\n\n/* BUTTON */\n.buttonBlackText {\n\tcolor: #000;\n      font-size: 1.3rem;\n     font-weight: 400;\n     text-align: center;\n     width: 200px ;\n\t height: 50px;\n     justify-content: center;\n    line-height: 50px;\n   border-radius: 6px;\n   cursor:pointer;\n}\n\n.buttonWhiteText {\n\tcolor: #fff;\n      font-size: 1.3rem;\n     font-weight: 400;\n     text-align: center;\n     width: 200px ;\n\t height: 50px;\n     justify-content: center;\n   border-radius: 6px;\n   cursor:pointer;\n}\n\n\n\n.buttonBlackText3 {\n  color: #000;\n  font-size: 17px;\n  font-weight: 400;\n  text-align: center;\n  width: 200px;\n  height: 50px;\n  justify-content: center;\n  line-height: 50px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.buttonWhiteText3 {\n  color: #fff;\n  font-size: 17px;\n  font-weight: 400;\n  text-align: center;\n  width: 200px;\n  height: 50px;\n  justify-content: center;\n  line-height: 50px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n\n.hero-section {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.parallax-bg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 10;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 0 1rem;\n}\n\n.hero-title {\n  color: #fff;\n  font-size: 3rem;\n  line-height: 3.1rem;\n  font-weight: bold;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n}\n\n\n.hero-title-pc {\n  color: #fff;\n  font-size: 2.4rem;\n  line-height: 2.6rem;\n  font-weight: bold;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n}\n\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .hero-title-pc {\n    font-size: 2.6rem;\n    line-height: 2.7rem;\n  }\n}\n\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .hero-title-pc {\n    font-size: 3rem;\n    line-height: 3.1rem;\n  }\n}\n\n.hero-title-mobile {\n  color: #fff;\n  font-size: 2.5rem;\n  line-height: 2.6rem;\n  font-weight: bold;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n}\n\n\n\n.highlight {\n  color: #facc15; /* jaune doré */\n}\n\n.hero-subtitle {\n  margin-top: 1rem;\n  font-size: 2.3rem;\n  line-height: 2rem;\n  color: white;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n}\n\n.big-dec-txt-pc {\n  font-size: 5rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .big-dec-txt-pc {\n    font-size: 6.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .big-dec-txt-pc {\n    font-size: 8rem;\n  }\n}\n\n\n.mid-dec-txt-pc {\n  font-size: 3rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .mid-dec-txt-pc {\n    font-size: 4.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .mid-dec-txt-pc {\n    font-size: 4rem;\n  }\n}\n\n\n.mid-dec-txt-tablet {\n  font-size: 3.3rem;\n}\n\n.mid-dec-txt-phone {\n  font-size: 2rem;\n}\n\n\n\n.big-dec-txt-subtxt-pc {\n  font-size: 1.6rem;\n  line-height: 1.8rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .big-dec-txt-subtxt-pc {\n    font-size: 1.8rem;\n    line-height: 2rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .big-dec-txt-subtxt-pc {\n    font-size: 2rem;\n    line-height: 2.2rem;\n  }\n}\n\n\n\n\n\n\n.small-box-txt-sz-pc {\n  font-size: 21px;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .small-box-txt-sz-pc {\n    font-size: 25px;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .small-box-txt-sz-pc {\n    font-size: 5rem;\n  }\n}\n\n\n.small-box-small-txt-sz-pc {\n  font-size: 17px;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .small-box-small-txt-sz-pc {\n    font-size: 18px;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .small-box-small-txt-sz-pc {\n    font-size: 20px;\n  }\n}\n\n\n.page-title-phone {\n  font-size: 1.8rem;\n}\n\n\n.page-title-pc {\n  font-size: 2.3rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .page-title-pc {\n    font-size: 2.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .page-title-pc {\n    font-size: 2.7rem;\n  }\n}\n\n.page-subtitle-pc {\n  font-size: 2rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .page-subtitle-pc {\n    font-size: 2.3rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .page-subtitle-pc {\n    font-size: 2.5rem;\n  }\n}\n\n\n.page-subsubtitle-pc {\n  font-size: 1.3rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .page-subsubtitle-pc {\n    font-size: 1.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .page-subsubtitle-pc {\n    font-size: 1.7rem;\n  }\n}\n\n\n.page-subsubtitle-phone {\n  font-size: 1rem;\n  line-height: 1.2rem;\n}\n\n\n.menu-name-pc {\n  font-size: 16px;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .menu-name-pc {\n    font-size: 17px;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .menu-name-pc {\n    font-size: 18px;\n  }\n}\n\n\n.menu-name-tablet {\n  font-size: 17px;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .menu-name-tablet {\n    font-size: 18px;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .menu-name-tablet {\n    font-size: 19px;\n  }\n}\n\n\n.motion-h1-pc {\n  font-size: 2rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-h1-pc {\n    font-size: 2.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-h1-pc {\n    font-size: 2.8rem;\n  }\n}\n\n.motion-h1-sub-pc {\n  font-size: 1.7rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-h1-sub-pc {\n    font-size: 1.8rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-h1-sub-pc {\n    font-size: 1.9rem;\n  }\n}\n\n\n.motion-h1-sub-phone {\n  font-size: 1.4rem;\n}\n\n\n.img-border-radius-pc {\n  border-radius: 0.7rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .img-border-radius-pc {\n    border-radius: 0.9rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .img-border-radius-pc {\n    border-radius: 1rem;\n  }\n}\n\n\n\n.motion-div-small-pc {\n  font-size: 1rem;\n  line-height: 1.3rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-div-small-pc {\n    font-size: 1.2rem;\n    line-height: 1.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-div-small-pc {\n    font-size: 1.5rem;\n    line-height: 1.8rem;\n  }\n}\n\n\n.motion-div-small-tablet {\n  font-size: 1.3rem;\n  line-height: 1.6rem;\n}\n\n.motion-div-small-phone {\n  font-size: 1rem;\n  line-height: 1.2rem;\n}\n\n\n\n.motion-div-smallest-pc {\n  font-size: 0.9rem;\n  line-height: 1.1rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-div-smallest-pc {\n    font-size: 1.1rem;\n    line-height: 1.3rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-div-smallest-pc {\n    font-size: 1.3rem;\n    line-height: 1.5rem;\n  }\n}\n\n\n\n.motion-div-default-pc {\n  font-size: 1.1rem;\n  line-height: 1.3rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-div-default-pc {\n    font-size: 1.3rem;\n    line-height: 1.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-div-default-pc {\n    font-size: 1.6rem;\n    line-height: 1.9rem;\n  }\n}\n\n\n\n.motion-div-title-pc {\n  font-size: 1.7rem;\n  line-height: 1.9rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-div-title-pc {\n    font-size: 2.3rem;\n    line-height: 2.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-div-title-pc {\n    font-size: 2.5rem;\n    line-height: 2.7rem;\n  }\n}\n\n\n\n.motion-div-subtitle-pc {\n  font-size: 1.4rem;\n  line-height: 1.6rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-div-subtitle-pc {\n    font-size: 2rem;\n    line-height: 2.2rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-div-subtitle-pc {\n    font-size: 2.2rem;\n    line-height: 2.4rem;\n  }\n}\n\n\n\n\n/* HEADER */\n.menu-modal-transl {\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.main_header {\n\tposition:fixed;\n\tz-index:99;\n\ttop:10px;\n\tright: 25px;\n   width: 100%;\n   height: 70px;\n  border-bottom: rgba(53,3,176,1);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.main_header_okd {\n\tposition:fixed;\n\tz-index:99;\n\ttop:0;\n\tleft: 0;\n   width: 100%;\n   height: 70px;\n  border-bottom: rgba(53,3,176,1);\n  background: rgb(53,3,176);\nbackground: -moz-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);\nbackground: -webkit-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);\nbackground: linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);\nfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#3503b0\",endColorstr=\"#9e10bf\",GradientType=1);\n}\n\n.main_header_connected{\n\tposition:fixed;\n\tz-index:9;\n\ttop:0;\n\tleft: 0;\n   width: 100%;\n   height: 70px;\n   background: rgb(53,3,176);\n background: -moz-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);\n background: -webkit-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);\n background: linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);\n filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#3503b0\",endColorstr=\"#9e10bf\",GradientType=1);\n  overflow: hidden;\n}\n\n\n.main_header_inside {\n\twidth: 98%;\n       height: 60px;\n\tmargin: auto;\n\tmargin-top:5px;\n      overflow: hidden;\n}\n\n.main_header_inside_mobile {\n\twidth: 98%;\n       height: 50px;\n\tmargin: auto;\n\tmargin-top:5px;\n      overflow: hidden;\n}\n\n\n\n\n.main_header_inside_left {\n       width: 170px;\n       height: 50px;\n\t    justify-content: center;\n\t   line-height: 50px;\n\t   float: left;\n}\n\n.main_header_inside_left_2 {\n       height: 50px;\n\t    justify-content: center;\n\t   line-height: 50px;\n\t   float: left;\n\t   margin-left: 30px;\n}\n\n.main_header_inside_left_2 a{\n\tdisplay: inline-block;\n\twidth: 100px;\n\ttext-align: center;\n\tfont-size: 16px;\n}\n\n\n.main_header_inside_left img{\n\twidth: 170px;\n\t vertical-align: middle;\n}\n\n.main_header_inside_left_mobile {\n\twidth: 30%;\n       height: 50px;\n\t    justify-content: center;\n\t   line-height: 50px;\n\t   float: left;\n}\n.main_header_inside_left_mobile img{\n\twidth: 100%;\n\t vertical-align: middle;\n}\n\n\n\n.main_header_inside_center {\n\tmargin-left: 20px;\n\twidth: 480px;\n       height: 44px;\n\t   margin-top:3px;\n    justify-content: center;\n\t float: left;\n}\n\n\n\n\n.main_header_inside_center_mobile {\n\ttext-align:  center;\n\twidth: 40%;\n       height: 50px;\n\t   line-height: 50px;\n\t   float: left;\n}\n.main_header_inside_center_mobile img{\n\twidth: 100%;\n\t vertical-align: middle;\n}\n\n\n.main_header_inside_right {\n\tposition: relative;\n\ttext-align:  right;\n\twidth: 350px;\n       height: 50px;\n\t   float: right;\n}\n.main_header_inside_right img{\n\theight: 50px;\n\t vertical-align: middle;\n}\n\n\n.main_header_inside_right_1 {\n\tposition: relative;\n\t   float: right;\n\t   margin-left:20px;\n\t     margin-top:5px;\n}\n\n.main_header_inside_right_2 {\n\tposition: relative;\n\t   float: right;\n\t   margin-top:5px;\n}\n\n\n.main_header_inside_right_mobile {\n\tposition: relative;\n\ttext-align:  right;\n\twidth: 30%;\n       height: 50px;\n\t     line-height: 50px;\n\t   float: right;\n}\n.main_header_inside_right_mobile img{\n\twidth: 100%;\n\t vertical-align: middle;\n}\n\n\n\n.menu_container {\n  position: fixed;\n  top: 19px;\n  right: 7px;\n  height: 27px;\n  width: 35px;\n  cursor: pointer;\n  z-index: 9999;\n  transition: opacity .25s ease;\n\n  &:hover {\n    opacity: 1;\n  }\n\n  &.active {\n    .top {\n      transform: translateY(11px) translateX(0) rotate(45deg);\n      background: #777;\n    }\n    .middle {\n      opacity: 0;\n      background: #777;\n    }\n\n    .bottom {\n      transform: translateY(-11px) translateX(0) rotate(-45deg);\n      background: #777;\n    }\n  }\n\n  span {\n  background: #fff;\n  border: none;\n  height: 3px;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition:  all .35s ease;\n  cursor: pointer;\n\n    &:nth-of-type(2) {\n      top: 11px;\n    }\n\n    &:nth-of-type(3) {\n      top: 22px;\n    }\n  }\n}\n\n\n\n.overlay {\n  position: fixed;\n   z-index: 10;\n  background: #fff;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 0%;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity .35s, visibility .35s, height .35s;\n  overflow: hidden;\n\n  &.open {\n    opacity: 1;\n    visibility: visible;\n    height: 100%;\n\n    li {\n      animation: fadeInRight .5s ease forwards;\n      animation-delay: .35s;\n\n      &:nth-of-type(2) {\n        animation-delay: .4s;\n      }\n      &:nth-of-type(3) {\n        animation-delay: .45s;\n      }\n      &:nth-of-type(4) {\n        animation-delay: .50s;\n      }\n    }\n  }\n  nav {\n    position: relative;\n    height: 70%;\n    top: 35%;\n    transform: translateY(-50%);\n    font-size: 20px;\n    font-family: 'Lato', sans-serif;\n    font-weight: 400;\n    text-align: center;\n    width: 98% ;\n\tmargin: auto;\n  }\n  ul {\n    list-style: none;\n    padding: 0;\n    margin: 0 auto;\n    display: inline-block;\n    position: relative;\n    height: 100%;\n     width: 100% ;\n\n    li {\n      display: block;\n      height: 50px;\n      min-height: 50px;\n\t  line-height: 50px;\n\t  width: 100% ;\n      position: relative;\n      opacity: 0;\n\n      a {\n        display: block;\n        position: relative;\n        color: #333;\n        text-decoration: none;\n        overflow: hidden;\n        vertical-align: middle;\n\n        &:hover:after,\n         &:focus:after,\n         &:active:after {\n           width: 100%;\n         }\n\n        &:after {\n          content: '';\n          position: absolute;\n          bottom: 0;\n          left: 50%;\n          width: 0%;\n          transform: translateX(-50%);\n          height: 3px;\n          background: #FFF;\n          transition: .35s;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
